// How-to videos, keyed by the `docs.videoId` values used in registry.js.
// The registry stores only ids; the hosted location lives here so moving the
// videos (or switching host) is a one-file change.
//
// To publish a video for a page:
//   1. Upload the mp4 (docs/training/video-pipeline output) to the public
//      website / CDN.
//   2. Add it here: id -> { title, url, poster? }.
//   3. Set docs.videoId on the page's registry entry.
// The help drawer picks it up automatically.

const VIDEOS = {
  // 'event-planning-02': {
  //   title: 'Planning an event',
  //   url: 'https://www.ambunet.co.uk/videos/event-planning-02.mp4',
  // },
}

export const getHelpVideo = (videoId) => (videoId ? VIDEOS[videoId] : undefined)

export default VIDEOS
